import { render, staticRenderFns } from "./prepay.vue?vue&type=template&id=bc13e486&scoped=true&"
import script from "./prepay.vue?vue&type=script&lang=js&"
export * from "./prepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13e486",
  null
  
)

export default component.exports